
export const POST_MESSAGE_CONTEXT = {
  EXPORT_REPORT: 'exportReport',
  REDEEM_PROMO_CODE: 'redeemPromoCode',
  ABSENT_WORKER: 'absentWorker'
};

// must match library:
// https://github.com/nilpath/redux-postmessage-middleware/blob/master/src/constants.ts
export const POST_MESSAGE_ACTION_PREFIX = '@redux-postmessage';
